module.exports = __webpack_public_path__ + "assets/retina_Angle60Detailed.d57dc1ea07d6aa132e3dceff51eeecd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_Angle60Detailed.png
// module id = 617
// module chunks = 0